import { Menu, popoverClasses } from "@mui/material";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { DeviationStamp } from "features/deviations";
import { DitioMachineStamp } from "features/ditio";
import { DitioChecklistStamp } from "features/ditio/stamps/checklist";
import { ClassificationStamp } from "features/pointVisualization/classificationStamp";
import { PropertiesStamp } from "features/properties";
import { LogPointStamp, MachineLocationStamp as XsiteMachineLocationStamp } from "features/xsiteManage";
import { selectIsProcoreDesign, selectIsProcoreMobileDesign } from "slices/explorer";

import { CanvasContextMenuStamp } from "./canvasContextMenuStamp";
import { ProcoreMobileContextMenuStamp } from "./canvasContextMenuStamp/procoreMobileStamp";
import { ProcoreCanvasContextMenuStamp } from "./canvasContextMenuStamp/procoreStamp";
import { renderActions, selectStamp } from "./renderSlice";
import { StampKind } from "./types";

export function Stamp() {
    const dispatch = useAppDispatch();
    const stamp = useAppSelector(selectStamp);
    const isProcoreDesign = useAppSelector(selectIsProcoreDesign);
    const isProcoreMobileDesign = useAppSelector(selectIsProcoreMobileDesign);

    if (!stamp) {
        return null;
    }

    return (
        <Menu
            open={true}
            onClose={() => dispatch(renderActions.setStamp(null))}
            disableEnforceFocus
            disableAutoFocus
            autoFocus={false}
            disableAutoFocusItem
            disableRestoreFocus
            sx={{
                [`&.${popoverClasses.root}`]: {
                    pointerEvents: "none",
                    padding: 0,
                },
            }}
            anchorReference="anchorPosition"
            anchorPosition={{ top: stamp.mouseY + 8, left: stamp.mouseX + 24 }}
            transitionDuration={{ exit: 0, enter: 150 }}
        >
            {stamp.kind === StampKind.XsiteManageMachineLocation ? (
                <XsiteMachineLocationStamp />
            ) : stamp.kind === StampKind.LogPoint ? (
                <LogPointStamp />
            ) : stamp.kind === StampKind.Deviation ? (
                <DeviationStamp />
            ) : stamp.kind === StampKind.CanvasContextMenu ? (
                isProcoreDesign ? (
                    isProcoreMobileDesign ? (
                        <ProcoreMobileContextMenuStamp />
                    ) : (
                        <ProcoreCanvasContextMenuStamp />
                    )
                ) : (
                    <CanvasContextMenuStamp />
                )
            ) : stamp.kind === StampKind.Properties ? (
                <PropertiesStamp />
            ) : stamp.kind === StampKind.DitioMachine ? (
                <DitioMachineStamp />
            ) : stamp.kind === StampKind.DitioChecklist ? (
                <DitioChecklistStamp />
            ) : stamp.kind === StampKind.Classification ? (
                <ClassificationStamp />
            ) : null}
        </Menu>
    );
}
